import * as React from 'react'
import { Button } from '@/components/shadcn/button'
import { IconExpandChevronOutline } from '@icons/IconExpandChevronOutline'
import { Column } from '@tanstack/react-table'
import { cn } from '@/lib/utils'
import { ButtonProps } from '@/components/shadcn/button'

import { MarkdownDocumentationHover } from '@/catalog-apps/components/component-library/MdTextComponent/MarkdownDocumentationHover'
import { IconV2ArrowRightOutline } from '@icons/IconV2ArrowRightOutline'
interface SortingHeaderButtonProps<TData> extends ButtonProps {
  column: Column<TData>
  children: React.ReactNode
  description?: string
}

const SortingHeaderButton = <TData,>(props: SortingHeaderButtonProps<TData>, ref: React.Ref<HTMLButtonElement>) => {
  const { column, children, className, description, ...restProps } = props
  const sortingIcons = (
    <>
      {!column.getIsSorted() ? (
        <IconExpandChevronOutline className="size-3" />
      ) : column.getIsSorted() === 'asc' ? (
        <IconV2ArrowRightOutline className="size-3 rotate-90" />
      ) : column.getIsSorted() === 'desc' ? (
        <IconV2ArrowRightOutline className="size-3 -rotate-90" />
      ) : null}
    </>
  )
  return (
    <Button
      className={cn('inline-flex shrink-0 items-center gap-2 whitespace-nowrap p-0 font-bold', className)}
      variant="ghost"
      onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
      ref={ref}
      {...restProps}
    >
      {description ? (
        <MarkdownDocumentationHover documentation={description} contentClassName="z-[100]">
          <span className="cursor-default whitespace-nowrap">{children}</span>
        </MarkdownDocumentationHover>
      ) : (
        <span className="whitespace-nowrap">{children}</span>
      )}
      {sortingIcons}
    </Button>
  )
}

type ForwardedSortingHeaderButtonType = <TData>(
  props: SortingHeaderButtonProps<TData> & { ref?: React.Ref<HTMLButtonElement> }
) => React.ReactElement

const ForwardedSortingHeaderButton = React.forwardRef(SortingHeaderButton) as ForwardedSortingHeaderButtonType & {
  displayName?: string
}

ForwardedSortingHeaderButton.displayName = 'SortingHeaderButton'

export { ForwardedSortingHeaderButton as SortingHeaderButton }
